/* PLUGINS */
import Vue from 'vue'
import VueStash from 'vue-stash';
import store from './store'
import VueRouter from 'vue-router'
import VueGtag from "vue-gtag";
import VueAuth from '@websanova/vue-auth'
import auth from './auth'
import VueAxios from 'vue-axios'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import Vue2Filters from 'vue2-filters'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueI18n from 'vue-i18n'
import VueI18nFilter from 'vue-i18n-filter'
import "@babel/polyfill"
import animateScrollTo from 'animated-scroll-to'
import VueSimpleSVG from 'vue-simple-svg'
import IsInViewport from "is-in-viewport/lib/isInViewport"
import OverlayScrollbarsJs from "overlayscrollbars/js/OverlayScrollbars"
import OverlayScrollbarsCss from "overlayscrollbars/css/OverlayScrollbars.css"
require('./bootstrap')
var VueTruncate = require('vue-truncate-filter')
import Menu from './menu'
import Style from './style'
import moment from 'moment-timezone'

window.Vue = Vue
window.Style = Style
window.animateScrollTo = animateScrollTo
window.IsInViewport = IsInViewport
window.moment = moment

/* AXIOS SETUP */
Vue.axios = axios
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.baseURL = '/api'
let token = document.head.querySelector('meta[name="csrf-token"]')
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

axios.interceptors.response.use((response) => response, (error) => {


    if (error.response.statusText == 'Unauthorized'){
        window.localStorage.removeItem('laravel-vue-spa-2');
    }else{
        return Promise.reject(error);
    }
});

/* ROUTES */
const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

const routes = [
  { path: '/', name: 'home', component: Vue.component('HomePage'), meta: { titleKey: 'home' } },
  { path: '/book', name: 'book', component: Vue.component('BookPage'), meta: { titleKey: 'book' } },
  { path: '/cart', name: 'cart', component: Vue.component('CartPage'), meta: { titleKey: 'cart', auth: true } },
  { path: '/booking-success', name: 'bookingsuccess', component: Vue.component('BookingSuccessPage'), meta: { titleKey: 'bookingsuccess', auth: true } },
  { path: '/contact', name: 'contact', component: Vue.component('ContactPage'), meta: { titleKey: 'contact' } },
  { path: '/discover', name: 'discover', component: Vue.component('DiscoverPage'), meta: { titleKey: 'discover' } },
  { path: '/faq', name: 'faq', component: Vue.component('FAQ'), meta: { titleKey: 'faq' } },
  { path: '/terms-of-use', name: 'terms', component: Vue.component('TermsPage'), meta: { titleKey: 'terms' } },
  { path: '/privacy-policy', name: 'privacy', component: Vue.component('PrivacyPage'), meta: { titleKey: 'privacy' } },
  { path: '/legal-policy', name: 'legal', component: Vue.component('LegalPage'), meta: { titleKey: 'legal' } },
  { path: '/cookies-policy', name: 'cookies-policy', component: Vue.component('CookiesPage'), meta: { titleKey: 'cookies' } },
  { path: '/what-s-on', name: 'blog', component: Vue.component('BlogPage'), meta: { titleKey: 'blog' } },
  { path: '/blog', name: 'articles', component: Vue.component('ArticlesPage'), meta: { titleKey: 'articles' } },
  { path: '/blog/category/:id', name: 'articlescategory', component: Vue.component('ArticlesPage'), meta: { titleKey: 'articlescategory' } },
  { path: '/blog/post/:id', name: 'blogpost', component: Vue.component('BlogPostPage'), meta: { titleKey: 'blogpost' } },
  { path: '/events', name: 'events', component: Vue.component('EventsPage'), meta: { titleKey: 'events' } },
  { path: '/events/category/:id', name: 'eventscategories', component: Vue.component('EventsPage'), meta: { titleKey: 'eventscategories' } },
  { path: '/events/:id', name: 'event', component: Vue.component('EventPage'), meta: { titleKey: 'event' } },
  { path: '/register', name: 'register', component: Vue.component('RegisterPage'), meta: { titleKey: 'register' } },
  { path: '/register-success', name: 'registersuccess', component: Vue.component('RegisterSuccessPage'), meta: { titleKey: 'registersuccess', auth: true } },
  { path: '/email-confirmed', name: 'emailconfirmed', component: Vue.component('EmailConfirmedPage'), meta: { titleKey: 'emailconfirmed' } },
  { path: '/login', name: 'login', component: Vue.component('LoginPage'), meta: { titleKey: 'login' } },
  { path: '/password/reset/:token', name: 'passwordreset', component: Vue.component('PasswordResetPage'), meta: { titleKey: 'passwordreset', auth: false } },
  { path: '/forgot-password', name: 'forgotpassword', component: Vue.component('ForgotPasswordPage'), meta: { titleKey: 'forgotpassword', auth: false } },
  { path: '/dashboard', name: 'dashboard', component: Vue.component('DashboardPage'), meta: { titleKey: 'dashboard', auth: true } },
  { path: '/profile', name: 'profile', component: Vue.component('ProfilePage'), meta: { titleKey: 'profile', auth: true } },
  { path: '/giftcards', name: 'giftcards', component: Vue.component('GiftcardsPage'), meta: { titleKey: 'giftcards', auth: true } },
  { path: '*', name: 'notfound', component: Vue.component('NotFoundPage'), meta: { titleKey: 'notfound' } }
];

const messages = {
  en: {
    home: '',
    book: 'Book a room',
    cart: 'Your cart',
    bookingsuccess: 'Booking Success',
    contact: 'Contact',
    discover: 'Discover',
    terms: 'Terms of Use',
    privacy: 'Privacy Policy',
    legal: 'Legal Policy',
    cookies: 'Cookies Policy',
    blog: 'What\'s On',
    articles: 'Articles',
    articlescategory: 'Articles',
    blogpost: 'Article',
    events: 'Events',
    eventscategories: 'Events',
    event: 'Event',
    register: 'Register',
    registersuccess: 'Register Success',
    emailconfirmed: 'Email Confirmed',
    login: 'Login',
    passwordreset: 'Password Reset',
    forgotpassword: 'Forgot Password',
    dashboard: 'Dashboard',
    profile: 'Profile',
    notfound: 'Page Not Found',
    faq: 'FAQ'
  },
  // Ajoutez ici d'autres langues
  fr: {
    home: '',
    book: 'Réserver une salle',
    cart: 'Votre panier',
    bookingsuccess: 'Succès de réservation',
    contact: 'Contact',
    discover: 'Découvrir',
    terms: 'Conditions d\'utilisation',
    privacy: 'Politique de confidentialité',
    legal: 'Politique juridique',
    cookies: 'Politique des cookies',
    blog: 'Quoi de neuf',
    articles: 'Articles',
    articlescategory: 'Articles',
    blogpost: 'Article',
    events: 'Événements',
    eventscategories: 'Événements',
    event: 'Événement',
    register: 'Inscription',
    registersuccess: 'Inscription réussie',
    emailconfirmed: 'Email confirmé',
    login: 'Connexion',
    passwordreset: 'Réinitialisation du mot de passe',
    forgotpassword: 'Mot de passe oublié',
    dashboard: 'Tableau de bord',
    profile: 'Profil',
    notfound: 'Page non trouvée',
    faq: 'FAQ'
  }
};

const router = new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior: (to, from, savedPosition) => new Promise((resolve) => {
    const position = savedPosition || {};
    if (!savedPosition) {
      if (to.hash) {
        position.selector = to.hash
      } else {
        position.x = 0
        position.y = 0
      }
    }
    router.app.$root.$once('triggerScroll', () => {
      router.app.$nextTick(() => resolve(position))
    });
  }),
})

/* LOCALE */
if(!localStorage.locale) {
  localStorage.locale = 'en'
}
const i18n = new VueI18n({
  locale: localStorage.locale,
  messages
})

/* Editorial wordings (managed in Nova) merged into vue-i18n.
   Inlined in the SPA shell (window.__WORDINGS__) to avoid an untranslated-text flash;
   falls back to GET /api/wordings if absent. */
function mergeWordings(payload) {
  if (!payload) return
  ['fr', 'en'].forEach((locale) => {
    if (payload[locale]) i18n.mergeLocaleMessage(locale, payload[locale])
  })
}
if (window.__WORDINGS__) {
  mergeWordings(window.__WORDINGS__)
} else {
  axios.get('/wordings').then(({ data }) => mergeWordings(data)).catch(() => {})
}

router.beforeEach((to, from, next) => {
  const titleKey = to.meta.titleKey;
  // Prefer the editable wording (w.titles.*); fall back to the bundled title.
  let translatedTitle = '';
  if (titleKey) {
    const wKey = 'w.titles.' + titleKey;
    translatedTitle = router.app.$i18n.t(wKey);
    if (translatedTitle === wKey) translatedTitle = router.app.$i18n.t(titleKey);
  }
  //if translated title is empty, use the default title
  document.title = translatedTitle.length > 0 ? `Enter the Sonotron - ${translatedTitle}` : "Enter the Sonotron";
  next();
});

Vue.router = router



/* PLUGINS */
Vue.use(VueRouter)
Vue.use(VueAuth, auth)
Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.use(VueStash)
Vue.use(VueSimpleSVG)
Vue.use(VueAwesomeSwiper)
// Vue.use(VueI18n)
Vue.use(VueI18nFilter)
Vue.use(VueTruncate)

Vue.use(VueGtag, {
  config: { id: "G-2VT76DC910" },
  bootstrap: false
}, router);

/* FILTERS */
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

/* DATE */
Vue.filter('formatDate', function(value) {
  if (value) {
    // Forcer la timezone Luxembourg pour éviter les décalages
    const dateStr = String(value);
    const date = moment.tz(dateStr, 'Europe/Luxembourg');
    
    if(localStorage.locale == "en") {
      return date.locale("en").format('ddd. DD/MM/YYYY')
    }
    return date.locale("fr").format('ddd DD/MM/YYYY')
  }
})

Vue.filter('formatDateBlog', function(value) {
  if (value) {
    return moment.tz(String(value), 'Europe/Luxembourg').format('DD.MM.YYYY')
  }
})

Vue.filter('formatDateEvent', function(value) {
  if (value) {
    return moment.tz(String(value), 'Europe/Luxembourg').format('DD/MM/YYYY')
  }
})

Vue.filter('formatTimeEvent', function(value) {
  if (value) {
    return  moment(value, "HH:mm").format("H:mm");
  }
})

/* VUE APP MOUNT */
const app = new Vue({
  router,
  i18n,
  data: {store}
}).$mount('#app')

window.app = app

window.isApp = false;

window.setApp = function(locale){
    window.isApp = true;
    window.app._i18n.locale = locale;
}


Vue.axios.get('/auth/user').then( ({data}) => {
    store.updateUser(data.data);
}).catch( () => {});

// Clean logs
// console.log = console.info = console.error = console.warn = function() {};



